import { TrendingDown, TrendingUp } from 'lucide-react';

const fmt = (n) => `${Math.round(Number(n) || 0).toLocaleString('fr-CA')} $`;

// Orange flag when the price changed since the last printed window sticker
export const PriceChangedBadge = ({ vehicle, compact = false }) => {
  if (!vehicle.sticker_price_changed) return null;
  const current = Number(vehicle.regular_price || vehicle.price || 0);
  const printed = Number(vehicle.sticker_printed_price || 0);
  const Icon = current < printed ? TrendingDown : TrendingUp;
  return (
    <div
      className={`inline-flex items-center gap-1 rounded-full bg-orange-100 text-orange-700 border border-orange-300 font-semibold whitespace-nowrap ${
        compact ? 'text-[9px] px-1.5 py-0.5 mt-0.5' : 'text-[11px] px-2 py-0.5 shadow'
      }`}
      title={`Étiquette imprimée à ${fmt(printed)} — prix actuel ${fmt(current)}. Réimprimez l'étiquette.`}
      data-testid={`price-changed-badge-${vehicle.id}`}
    >
      <Icon className={compact ? 'h-2.5 w-2.5' : 'h-3 w-3'} />
      {compact ? 'Prix changé' : `Prix changé: ${fmt(printed)} → ${fmt(current)}`}
    </div>
  );
};
